import store from '@/store';

export default (operation) => {
  const userOperations = store.getters['auth/operations'];

  return !!userOperations?.find((op) => op === operation);
};
